import { createAction } from 'redux-actions';

export const moduleName = 'emailConfirmation';

export const EMAIL_CONFIRMATION_PAGE_LOAD_REQUESTED = `${moduleName}/EMAIL_CONFIRMATION_PAGE_LOAD_REQUESTED`;
export const EMAIL_CONFIRMATION_PAGE_LOAD_SUCCEEDED = `${moduleName}/EMAIL_CONFIRMATION_PAGE_LOAD_SUCCEEDED`;
export const EMAIL_CONFIRMATION_PAGE_LOAD_FAILED = `${moduleName}/EMAIL_CONFIRMATION_PAGE_LOAD_FAILED`;

export const loadEmailConfirmationPageRequest = createAction(EMAIL_CONFIRMATION_PAGE_LOAD_REQUESTED);
export const loadEmailConfirmationPageSuccess = createAction(EMAIL_CONFIRMATION_PAGE_LOAD_SUCCEEDED);
export const loadEmailConfirmationPageFailure = createAction(EMAIL_CONFIRMATION_PAGE_LOAD_FAILED);
